import { Flex, Stack } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import CardWrapper from "./general/CardWrapper";

interface ITermsAndConditionsSectionProps {
  termsAndConditions: string;
  name: string;
  agreed?: boolean;
}

export default function TermsAndConditionsSection({
  termsAndConditions,
  name,
  agreed,
}: ITermsAndConditionsSectionProps) {
  const isAccepted = !!agreed;

  return (
    <div style={{ width: "100%" }}>
      <h4 className="h4" style={{ marginBottom: "var(--md)" }}>
        Termeni și condiții
      </h4>
      <CardWrapper>
        <Stack spacing="var(--md)">
          {/* Status banner */}
          <Flex
            align="center"
            gap="var(--xs)"
            style={{
              padding: "12px var(--sm)",
              borderRadius: 10,
              backgroundColor: isAccepted
                ? "rgba(43, 161, 47, 0.08)"
                : "var(--accent10)",
              border: `1.5px solid ${isAccepted ? "var(--green)" : "var(--accent)"}`,
            }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                backgroundColor: isAccepted ? "var(--green)" : "var(--accent)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {isAccepted ? (
                <IconCheck size={15} color="white" strokeWidth={2.5} />
              ) : (
                <IconX size={15} color="white" strokeWidth={2.5} />
              )}
            </div>
            <p
              className="p"
              style={{
                color: isAccepted ? "var(--green)" : "var(--accent)",
                fontWeight: 600,
                maxWidth: "none",
                flex: 1,
              }}
            >
              {isAccepted
                ? `Ai acceptat termenii și condițiile ${name}`
                : `Nu ai acceptat încă termenii și condițiile ${name}`}
            </p>
          </Flex>

          {/* Divider */}
          <div style={{ borderTop: "1px solid var(--divider)" }} />

          {/* Terms content */}
          <div
            className="terms-custom"
            dangerouslySetInnerHTML={{ __html: termsAndConditions }}
          />
        </Stack>
      </CardWrapper>
    </div>
  );
}
